// client/src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import AttorneyIntake from './pages/AttorneyIntake';
import AttorneyDashboard from './pages/AttorneyDashboard';
import ExpertDashboard from './pages/ExpertDashboard';
import ExpertIntake from './pages/ExpertIntake';
import MyProfile from './pages/MyProfile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ConfirmSignup from './pages/ConfirmSignup';
import AdminVerification from './pages/AdminVerification';
import Pricing from './pages/Pricing';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Navigation from './components/Navigation';
import HowItWorks from './pages/HowItWorks';
import TermsOfService from './pages/TermsOfService';
import AttorneyWaitlist from './pages/AttorneyWaitList';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { Analytics } from '@vercel/analytics/react';

export default function App() {
    return (
        <Router>
            <div className="min-h-screen bg-gray-50">
                <Navigation />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/confirm-signup" element={<ConfirmSignup />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/waitlist" element={<AttorneyWaitlist />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />

                    {/* SECURE ADMIN ROUTE - ONLY FOR AUTHORIZED ADMINS */}
                    <Route
                        path="/admin-verification"
                        element={
                            <AdminRoute>
                                <AdminVerification />
                            </AdminRoute>
                        }
                    />

                    {/* Attorney Routes */}
                    <Route
                        path="/attorney-intake"
                        element={
                            <ProtectedRoute>
                                <AttorneyIntake />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/attorney-dashboard"
                        element={
                            <ProtectedRoute>
                                <AttorneyDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/search-experts"
                        element={
                            <ProtectedRoute>
                                <AttorneyDashboard />
                            </ProtectedRoute>
                        }
                    />

                    {/* Expert Routes */}
                    <Route
                        path="/expert-dashboard"
                        element={
                            <ProtectedRoute>
                                <ExpertDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/expert-intake"
                        element={
                            <ProtectedRoute>
                                <ExpertIntake />
                            </ProtectedRoute>
                        }
                    />

                    {/* Profile Routes */}
                    <Route
                        path="/my-profile"
                        element={
                            <ProtectedRoute>
                                <MyProfile />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <ProtectedRoute>
                                <MyProfile />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
                <Analytics />
            </div>
        </Router>
    );
}
